<script>
    import { mapActions, mapMutations, mapState } from 'vuex';
    import { Form, Message } from "element-ui";
    import Loader from '~/components/loader/components/loader';
    import PasswordStrength from '~/components/password_strength/components/password_strength';
    import TogglePasswordInput from '~/components/toggle_password_input/components/toggle_password_input';
    import Vue from 'vue';
    import VueButton from '~/components/button/components/button';
    import Recaptcha from './recaptcha';

    Vue.use(Form);

    export default {
        name: 'security-question-answers-form',

        components: {
            Loader,
            PasswordStrength,
            TogglePasswordInput,
            VueButton,
            Recaptcha
        },

        props: {
            token: {
                type: String,
                required: true
            }
        },

        mounted() {
            this.getOrgSecurityQuestions(false);
        },

        computed: {
            ...mapState('passwordSettings', [
                'loading',
                'answerSecurityQuestionsForm',
                'isRecaptchaValid'
            ])
        },

        methods: {
            ...mapMutations('passwordSettings', [
                'setIsRecaptchaValid'
            ]),

            ...mapActions('passwordSettings', [
                'getOrgSecurityQuestions',
                'postAnswerSecurityQuestions',
                'validateRecaptcha'
            ]),

            validateForm() {
                let isValid = false;
                this.$refs.answerSecurityQuestionsForm.validate((result) => {
                    isValid = result;
                });

                if (isValid && this.isRecaptchaValid) {
                    this.submitSecurityQuestionAnswers();
                }
            },

            submitSecurityQuestionAnswers() {
                this.postAnswerSecurityQuestions(this.token).then((response) => {
                    Message.success('Security questions validated');
                    window.location.href = response.redirect_url;
                }).catch((e) => {
                    Message.error('Security questions invalid');
                    this.$refs.recaptcha.resetRecaptcha();
                });
            }
        }
    }
</script>

<template>
    <div>
        <loader :is-loading="loading.securityQuestions"></loader>

        <div class="security-questions-display">
            <el-form :model="answerSecurityQuestionsForm"
                     ref="answerSecurityQuestionsForm"
                     @submit.native.prevent>

                <div v-for="(securityQuestion, index) in answerSecurityQuestionsForm.securityQuestions">
                    <el-form-item :label="securityQuestion.question"
                                  :prop="'securityQuestions.' + index + '.answer'"
                                  :rules="{required: true, message: 'This is required.', trigger: 'blur'}">
                        <el-input class="security-question-input"
                                  placeholder="Answer"
                                  v-model="securityQuestion.answer"
                                  :maxlength="255">
                        </el-input>
                    </el-form-item>
                </div>
            </el-form>
        </div>

        <recaptcha ref="recaptcha"
                   @validationComplete="setIsRecaptchaValid">
        </recaptcha>
        <br/>

        <div class="login-buttons">
            <vue-button class="btn btn-block btn-primary btn-lg login-option-label"
                        type="primary"
                        @click="validateForm">
                Submit
            </vue-button>
        </div>
    </div>
</template>